module.exports = __webpack_public_path__ + "img/title.1d474f64.png";